export const loggingConstants = {
    ...getConstantObj()
};

function getConstantObj() {
    let obj = {
        getLogs_request: "getLogs_request",
        getLogs_success: "getLogs_success",
        getLogs_failure: "getLogs_failure",
    }

    let obj_formatted = {};
    let domain = "distributorPortal.logging/";
    for (let property in obj) {
        if (obj.hasOwnProperty(property)) {
            obj_formatted[property] = domain + obj[property];
        }
    }

    return obj_formatted;
}